export default "__VITE_ASSET__453a64a2__"